import { Program } from '~source/core/models/tv-guide';
import $ from './program-item.scss';
import { calculateDuration } from '~source/utils/calculate-duration';
import { calculateProgress } from '~source/utils/calculate-progress';
import { dateToTimeNotation } from '~source/utils/beautify-timing';
import cx from '~source/utils/join-class-names';
import { isMobileEpgPath } from '~source/utils/is-mobile-epg';
import { navigateToEpgDeepLink } from '~source/utils/epg-deeplink';
import { buildEpgWebUrl, navigateToEpgWebUrl } from '~source/utils/epg-web-url';

export interface ProgramItemProps {
    program: Program;
    isCurrent?: boolean;
    isPassed?: boolean;
    isNoContent?: boolean;
    now?: number;
}

export const ProgramItem: React.FC<ProgramItemProps> = ({
    program,
    isCurrent = false,
    isPassed = false,
    isNoContent = false,
    now,
}) => {
    if (isNoContent) {
        return (
            <div className={$['no-content']}>
                <span>Er zijn op deze dag op deze zender geen uitzendingen</span>
            </div>
        );
    }

    const startDate = new Date(program.dateStart);
    const endDate = new Date(program.dateEnd);
    const duration = calculateDuration(startDate, endDate);
    const progress = isCurrent
        ? calculateProgress(startDate, endDate, now ? new Date(now) : new Date())
        : 0;

    const inApp = isMobileEpgPath();

    const onClick = () => {
        if (!inApp) {
            const href = buildEpgWebUrl(program);
            if (!href) return;
            navigateToEpgWebUrl(program);
            return;
        }
        navigateToEpgDeepLink(program);
    };

    return (
        <div
            className={cx($.root, isCurrent && $.current)}
            data-current={isCurrent}
            data-passed={isPassed}
            onClick={onClick}
            role='button'
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (inApp) {
                        navigateToEpgDeepLink(program);
                    } else {
                        const href = buildEpgWebUrl(program);
                        if (!href) return;
                        navigateToEpgWebUrl(program);
                    }
                }
            }}
        >
            <span className={$.date}>{dateToTimeNotation(startDate)}</span>
            <h4 className={$.title}>{program.title}</h4>
            <div className={$.meta}>
                <span className={$.duration}>{duration}</span>
                {program.live && <span className={$.live}>LIVE</span>}
                {isCurrent && (
                    <div className={$.progress}>
                        <div style={{ width: `${progress}%` }} />
                    </div>
                )}
            </div>
        </div>
    );
};
